let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("35Ssm")).then(() => parcelRequire('j19wH'));